//** Imports */
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay]);
import { Fancybox } from '@fancyapps/ui';
Fancybox.bind("[data-fancybox]", {
        hideScrollbar: false,
});

// import { initGlobal } from './global';
import { initUpsalesForm } from './upsalesForm';
import { initUpsales } from './upsales';

/** Init Alpine only if price-puff-updated exists*/
if (document.getElementsByClassName('price-puff-updated').length != 0) {
    import('./pricePuffUpdated').then(function (page) {
        page.initPricePuffUpdated();
    });
}
/**
 * Init TS-files only if upsales block exists
 */
const upsalesBlock = document.querySelector(".upsales-block");

if (upsalesBlock) {
  initUpsales();
}

//** Swipers */
// Timeline Block
// - When time is available, rework this into a more scalabel solution. Now it was modified quickly to enable max two timeline-blocks on the same page.
const timelineBlock = document.querySelector(".timeline-block")
if (document.body.contains(timelineBlock)) {

  const timelineBlocks = document.querySelectorAll(".timeline-block")
  if (timelineBlocks.length == 1) {
    var menu = document.querySelectorAll(".section-name")
    let i = 1;
    let options = ['']
    options.shift()

    menu.forEach(i => {
      options.push(i.innerHTML)
    });

    const swiperTimeline = new Swiper('.swiper-timeline', {
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '"><span class="number">' + (i++) + '. </span>' + (options[index]) + '</span>';
        },
      },
      navigation: {
        nextEl: '.swiper-tl-next',
        prevEl: '.swiper-tl-prev',
      },
    })

  } else {
    var timelineOne = document.querySelector(".timeline-block")
    timelineOne.querySelector(".swiper-timeline").classList.add("tl-one")

    var timelineTwo = Array.from(document.querySelectorAll(".timeline-block")).pop()
    timelineTwo.querySelector(".swiper-timeline").classList.add("tl-two")

    var menuOne = timelineOne.querySelectorAll(".section-name")
    let i = 1;
    let options = ['']
    options.shift()
    menuOne.forEach(i => {
      options.push(i.innerHTML)
    });

    var menuTwo = timelineTwo.querySelectorAll(".section-name")
    let j = 1;
    let optionsTwo = ['']
    optionsTwo.shift()
    menuTwo.forEach(j => {
      optionsTwo.push(j.innerHTML)
    });

    const swiperTimeline = new Swiper('.tl-one', {
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '"><span class="number">' + (i++) + '. </span>' + (options[index]) + '</span>';
        },
      },
      navigation: {
        nextEl: '.swiper-tl-next',
        prevEl: '.swiper-tl-prev',
      }
    })

    const swiperTimelineTwo = new Swiper('.tl-two', {
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '"><span class="number">' + (j++) + '. </span>' + (optionsTwo[index]) + '</span>';
        },
      },
      navigation: {
        nextEl: '.swiper-tl-next',
        prevEl: '.swiper-tl-prev',
      },
    })
  }
}
//** Mobile Navigation */
const navToggle = document.querySelector("#nav-toggle")

navToggle.addEventListener("click", (e) => {
  const navLayout = document.querySelector(".mobile-nav")
  const headerLogo = document.querySelector(".header-logo")
  navToggle.classList.toggle("nav-toggle--active")
  navLayout.classList.toggle("mobile-nav--open")
  headerLogo.classList.toggle("header-logo--active")
})

//** Open megamenu on focus-visible */
const megamenus = document.querySelectorAll('.megamenu')
megamenus.forEach(megamenu => {
  const item = megamenu.querySelector('.link')
  // if (document.activeElement === megamenu.querySelector('.link')) {
  //   console.log("focused link")
  // }
});
//** Read More-toggles in Text-Image-block */
const readMoreToggles = document.querySelectorAll(".content__read-more")

readMoreToggles.forEach(toggle => {
  toggle.addEventListener("click", (e) => {
    toggle.parentElement.parentElement.parentElement.parentElement.parentElement.classList.toggle("read-more--open")
    let readMoreOpen = document.querySelector(".read-more--open")

    if (document.body.contains(readMoreOpen)) {
      setTimeout(function () {
        readMoreToggles[0].classList.remove("hide")
      }, 1000)
    } else {
      readMoreToggles[0].classList.add("hide")
    }
  })
})

//** Footer Toggle Feedback-form */
// const feedbackShow = document.querySelector(".feedback-show")
// const feedbackHide = document.querySelector(".close-feedback")
// const feedbackPopup = document.querySelector(".feedback-container")

// feedbackShow.addEventListener("click", () => {
//   feedbackPopup.classList.add("feedback-container--show")
// })

// feedbackHide.addEventListener("click", () => {
//   feedbackPopup.classList.remove("feedback-container--show")
// })

//** Copy to clipboard */
const copyIcon = document.querySelector(".clipboard-icon")

if (document.body.contains(copyIcon)) {
  const copyText = document.querySelector(".product-url").textContent
  const copyTextContainer = document.querySelector(".copy-text")
  copyIcon.addEventListener("click", (e) => {
    var tempInput = document.createElement("input");
    tempInput.value = copyText;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);
    copyTextContainer.classList.add("copy-text--show")
  })
}

